/**
 * @module state/rootDehydrate
 * Dehydrate state ready for localStorage.
 * Delegates to individual `state/<application>/dehydrate.js`.
 */

import appDehydrate from "state/app/dehydrate";
import teachersDehydrate from "state/teachers/dehydrate";
import schoolmoneyDehydrate from "state/school_money/dehydrate";

/**
 * rootDehydrate - dehydrate state into a form where it can be persisted efficiently
 * Mainly this involves deleting keys we don't want to serialize
 * This is delegated to the individual dehydrate methods in the app domains
 *
 * @returns {Immutable.Map} state
 */
export default function rootDehydrate(state) {
  return state
    .set("app",          appDehydrate( state.get("app") ))
    .set("teachers",     teachersDehydrate( state.get("teachers") ))
    .set("school_money", schoolmoneyDehydrate( state.get("school_money") ))
    .delete("router")
}



// WEBPACK FOOTER //
// ./src/state/rootDehydrate.js